import React, { useEffect, useState } from 'react';
import loadable from '@loadable/component';
import { isServer } from '../../../utils/device_detection/device_detection';
import LayerHost from '../../__core/LayerHost/LayerHost';

export const LoadableComponent = props => {
  const [CacheComponent, setCacheComponent] = useState();
  const [moduleName, setModuleName] = useState();
  const [useCacheComponent, setUseCacheComponent] = useState( false );

  useEffect( () => {
    if( props?.moduleName !== moduleName && !isServer() ){
      setModuleName( props.moduleName );
      setCacheComponent( loadable( () => import(
        /* webpackChunkName: "[request]" */
        /* webpackInclude: /\.js$/ */
        /* webpackExclude: /(test|stories)/ */
        `../${props.moduleName}/${props.moduleName}`
      ) ) );
      setUseCacheComponent( true );
    }
  }, [props.moduleName] );

  const Component = loadable( () => import(
    /* webpackChunkName: "[request]" */
    /* webpackInclude: /\.js$/ */
    /* webpackExclude: /(test|stories)/ */
    `../${props.moduleName}/${props.moduleName}`
  ) );


  return (
    <LayerHost
      Content={ useCacheComponent ? CacheComponent : Component }
      { ...props }
    />
  )

}


export default LoadableComponent;
